export default __webpack_public_path__ + "static/media/company-profile.81341d4f.svg";